import { TimeToFirstVisitByDayData } from '@components/Dashboard/CampaignAnalytics/slice/schema';
import { CA_LIGHT_BLUE_COLOR } from '@utils/colorGenerator';
import { fSimplePercentage } from '@utils/formatters';
import { AXIS_COLOR, baseChart } from './baseChart';
import { SUBHEADER_FONT_SIZE } from '@components/shared/Layout/ReportSectionCardHeader';
import Highcharts from 'highcharts';

const DAYS_COUNT = 31;

export const buildChartOptions = (
  data: TimeToFirstVisitByDayData[],
  hideOddDays?: boolean
): Highcharts.Options => ({
  ...baseChart,

  chart: {
    type: 'area',
    spacingRight: 50,
  },

  title: {
    text: 'Percentage of<br />All Visitors',
    useHTML: true,
    align: 'left',
    margin: 30,
    x: 20,
    style: {
      textAlign: 'center',
      fontSize: '14px',
    },
  },

  series: [
    {
      type: 'area',
      dataLabels: {
        enabled: false,
      },
      data: data
        .toSorted((a, b) => a.daysAfterAdExposure - b.daysAfterAdExposure)
        .slice(0, DAYS_COUNT)
        .map(dataItem => dataItem.percentageOfUsers),
      color: CA_LIGHT_BLUE_COLOR,
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      lineWidth: 0,
    },
  ],

  tooltip: {
    enabled: true,
    headerFormat: '',
    pointFormatter() {
      return `Day ${this.x}: ${fSimplePercentage(this.y, {
        maximumFractionDigits: 1,
        minimumFractionDigits: 1,
      })}`;
    },
  },

  xAxis: {
    startOnTick: false,
    endOnTick: false,
    minPadding: 0,
    maxPadding: 0,
    tickColor: AXIS_COLOR,
    labels: {
      overflow: 'allow',
      step: hideOddDays ? 2 : 0,
      autoRotation: undefined,
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
      formatter() {
        return `Day ${this.value}`;
      },
    },
    tickInterval: 1,
    tickLength: 5,
    min: 0,
    title: {
      align: 'low',
      textAlign: 'left',
      text: 'Days After Ad Exposure',
      margin: 20,
    },
  },

  yAxis: {
    lineColor: AXIS_COLOR,
    gridLineWidth: 0,
    tickColor: AXIS_COLOR,
    tickWidth: 1,
    tickLength: 5,
    lineWidth: 1,
    labels: {
      enabled: true,
      style: {
        fontSize: SUBHEADER_FONT_SIZE,
      },
      formatter() {
        return fSimplePercentage(Number.parseFloat(this.value.toString()), {
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        });
      },
    },
    title: {
      align: 'low',
      textAlign: 'left',
      text: 'Percentage',
      margin: 40,
    },
  },
});
